// extracted by mini-css-extract-plugin
export var wrapper = "style-module--wrapper--NxHIF";
export var ownBg = "style-module--ownBg--e0f3y";
export var title = "style-module--title--q7wN-";
export var subTitle = "style-module--subTitle--WShxF";
export var buttonWrapper = "style-module--buttonWrapper--aSW4K";